export const BASE_URL = null;
export const ASSET_PATH = './';

// dev | qa | prod
export const ENV = 'dev';

export const environment = {
  production: false,
  cmsUrl: `./assets/organization/org.cms.json`,
  helpCenterUrl: `./assets/organization/org.help-center-content.json`,
  assetPath: ASSET_PATH,
  cmsVariables:{
    loginUrl: '/login',
  },
  livePerson: {
    isEnabled: true,
    livePersonScriptUrl: './assets/js/live-person-monitor.js',
    siteId: '18037933'
  },
  adobeAnalytics: {
    isEnabled: true,
    scriptUrl: 'https://assets.adobedtm.com/eeb22595e0ba/dd429756bf36/launch-cb00d20d1aa2-development.min.js'
  },
  sso: {
    isEnabled: true,
    partnerName: 'Testing/Test_FusionIQ_PSP',
    defaultSsoUrl: 'https://service-demo.ssoexchange.com/ReliableInsurance/secure/login.do?PartnerName=${partnerName}&RelayState=${origin}',
    overrideSsoUrl: '',
    formTarget: 'https://digitalomni-intg.navyfederal.org/nfcu-online-banking/static/digital-investor',
    setCookie: false,
    cookieValue: ''
  }
};